import script from "./FormFile.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFile.vue?vue&type=script&setup=true&lang=js"

import "./FormFile.vue?vue&type=style&index=0&id=8e916a62&scoped=true&lang=css"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e916a62"]])

export default __exports__